var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"motivo-aula-compensada","rota-base":"/admin/motivo-aula-compensada","titulo":"Motivos de Aula Compensada (A.C)","titulo-singular":"Motivo de A.C","colunas-extras":[
        { campo: "descricao", label: "Descrição", tipo: "string" }
    ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }